import {
  insertNodes,
  InsertNodesOptions,
  PlateEditor,
  TText,
  Value,
} from '@udecode/plate-common';

import { MyAnchorLinkElement } from '../../../plateTypes';
import { createAnchorLinkNode, CreateAnchorLinkNodeOptions } from '../utils';

/** Insert an anchor link node. */
export const insertAnchorLink = <V extends Value>(
  editor: PlateEditor<V>,
  createLinkNodeOptions: CreateAnchorLinkNodeOptions,
  options?: InsertNodesOptions<V>,
): void => {
  insertNodes<MyAnchorLinkElement | TText>(
    editor,
    [createAnchorLinkNode(editor, createLinkNodeOptions)],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options as any,
  );
};
